import { combineReducers } from 'redux';
import {routerReducer as routing } from 'react-router-redux';

import strings from './stringsReducer';
import user from './userReducer';
import dsa from './dsaReducer';
import dsaConfig from './dsaConfigReducer';
import pptx from './pptxReducer';
import createDSAWorkflow from './createDSAWorkflowReducer';
import opportunities from './opportunitiesReducer';
import account from './accountReducer';
import stats from './statsReducer';
import xlsImports from './xlsImportsReducer';
import savingUpdatesText from './savingUpdatesTextReducer';

const rootReducer = combineReducers({
  routing,
  strings,
  user,
  dsa,
  dsaConfig,
  pptx,
  createDSAWorkflow,
  opportunities,
  account,
  stats,
  xlsImports,
  savingUpdatesText
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js